import { render, staticRenderFns } from "./tables-settings-list.vue?vue&type=template&id=dc25e190&scoped=true&"
import script from "./tables-settings-list.vue?vue&type=script&lang=js&"
export * from "./tables-settings-list.vue?vue&type=script&lang=js&"
import style0 from "./tables-settings-list.vue?vue&type=style&index=0&id=dc25e190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc25e190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc25e190')) {
      api.createRecord('dc25e190', component.options)
    } else {
      api.reload('dc25e190', component.options)
    }
    module.hot.accept("./tables-settings-list.vue?vue&type=template&id=dc25e190&scoped=true&", function () {
      api.rerender('dc25e190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/tables-settings-list.vue"
export default component.exports